import { render } from "./PersonForm.vue?vue&type=template&id=0f38c38c&ts=true"
import script from "./PersonForm.vue?vue&type=script&lang=ts"
export * from "./PersonForm.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/p2.findingyou.co/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__